const POST_STEPS = {
    INITIALIZATION: 'initialization',
    CONTENT_GENERATION: 'content_generation',
    AWAITING_FOR_MODERATION: 'awaiting_for_moderation',
    POST_PUBLISHING: 'post_publishing',
    NOTIFICATION_SENDING: 'notification_sending',
    FINISHED: 'finished',
    DELETE_POST_RESULT: 'deletePostResult',
};

const STATUS_STATES = {
    AWAITING: 'awaiting',
    STARTED: 'started',
    SUCCESS: 'success',
    FAILED: 'failed',
};

const MAX_ATTEMPTS = 3;

const SOURCE_TYPES = {
    MANUAL: 'manual',
    TRIGGER: 'trigger',
};

module.exports = {
    POST_STEPS,
    STATUS_STATES,
    MAX_ATTEMPTS,
    SOURCE_TYPES,
};



/** WEBPACK FOOTER **
 ** ../src/config/postConstants.js
 **/